import TsaPayRetainDialog from '@/components/PayRetainDialog/index.vue'
let $vm
let watcher

const plugin = {
  install (vue, pluginOptions = {}) {
    const PayRetainDialog = vue.extend(TsaPayRetainDialog)
    if (!$vm) {
      $vm = new PayRetainDialog({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    const signName = {
      show (options = {}) {
        $vm.show = true
        $vm.payLeave = options.payLeave || {}
        $vm.giveUp = options.giveUp
        $vm.useCoupons = options.useCoupons
      },
      update (payLeave) {
        $vm.payLeave = payLeave || {}
      },
      hide () {
        $vm.show = false
      }
    }
    if (!vue.prototype.$TsaPayRetainDialog) {
      vue.prototype.$TsaPayRetainDialog = signName
    }
  }
}

export default plugin
